import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class AvisMapaSelectorMeteors extends Component {

    constructor(props) {
        super(props);
        this.state = {controlCapesObert: false};
        this.gestionarControlCapesObert = this.gestionarControlCapesObert.bind(this);
        this.obrirControlCapes = this.obrirControlCapes.bind(this);
        this.tancarControlCapes = this.tancarControlCapes.bind(this);
    }

    componentDidMount() {
        // Aquest control s'afegeix per obrir/tacnar el control de capes on dispositius mòbils,
        // ja que en Safari iOS els events del ratolí no es mapejen automàticament a events de Touch
        window.addEventListener('touchend', this.gestionarControlCapesObert, false);
    }

    obrirControlCapes() {
        this.setState({controlCapesObert: true});
    }

    tancarControlCapes() {
        this.setState({controlCapesObert: false});
    }

    gestionarControlCapesObert(event) {
        if (this.state.controlCapesObert && !event.composedPath().includes(this.controlCapesObert)) {
            event.preventDefault();
            this.tancarControlCapes();
        } else if (!this.state.controlCapesObert && event.composedPath().includes(this.controlCapesTancat)) {
            event.preventDefault();
            this.obrirControlCapes();
        }
    }

    render() {
        const { meteors, onChangeMeteorSeleccionat, metadadesMeteors } = this.props;

        //Si no hi ha meteors no s'ha de mostrar el component
        if (!meteors || Object.keys(meteors).length === 0) return <div></div>;

        const checkboxMeteors = Object.keys(meteors).map((idMeteor) => {
            const meteor = metadadesMeteors[idMeteor];
            if (!meteor) { return null; }

            return <label key={idMeteor}>
                <input
                    type='checkbox'
                    style={{marginTop: '2px', position: 'relative', top: '1px'}}
                    value={idMeteor}
                    onChange={event => onChangeMeteorSeleccionat(event.target.value, event.target.checked)}
                    checked={meteors[idMeteor]} />
                <span> {meteor.nom}</span>
            </label>;
        });

        const controlCapesObert = (
            <div className='control-capes-panell'
                ref={ref => this.controlCapesObert = ref}
                onMouseLeave={this.tancarControlCapes}>
                {checkboxMeteors}
            </div>
        );
        const controlCapesTancat = (
            <div className='control-capes'
                ref={ref => this.controlCapesTancat = ref}
                onMouseEnter={this.obrirControlCapes}>
                <div className='control-capes-imatge' />
            </div>
        );

        return (
            <div>
                {this.state.controlCapesObert ? controlCapesObert : controlCapesTancat}
            </div>
        );
    }

    componentWillUnmount() {
        window.removeEventListener('touchend', this.gestionarControlCapesObert, false);
    }
}

AvisMapaSelectorMeteors.propTypes = {
    meteors: PropTypes.object,
    metadadesMeteors: PropTypes.object,
    onChangeMeteorSeleccionat: PropTypes.func
};

const mapStateToProps = (state) => {
    return { metadadesMeteors: state.avis.meteors };
};

export default connect(mapStateToProps, null)(AvisMapaSelectorMeteors);



// WEBPACK FOOTER //
// ./src/components/avis/avisMapaSelectorMeteors.js